import type { AvailableGameCatalogEntry } from '../../catalog-entry.js';
import { sortSpreadTestDescriptor } from './descriptor.js';

export const sortSpreadTestCatalogEntry = {
  descriptor: sortSpreadTestDescriptor,
  availability: 'diagnostic',
  load: async () => (await import('./sort-spread-test.js')).sortSpreadTestDefinition,
} satisfies AvailableGameCatalogEntry;
